import { useEffect } from 'react';
import styles from './ImageLightbox.module.css';

type ImageLightboxProps = {
  src: string;
  caption: string;
  closeLabel: string;
  onClose: () => void;
};

export function ImageLightbox({ src, caption, closeLabel, onClose }: ImageLightboxProps) {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className={styles.backdrop}
      role="dialog"
      aria-modal="true"
      aria-label={caption}
      onClick={onClose}
    >
      <div className={styles.panel} onClick={(event) => event.stopPropagation()}>
        <button type="button" className={styles.close} onClick={onClose} aria-label={closeLabel}>
          ×
        </button>
        <img src={src} alt={caption} className={styles.image} />
        {caption ? <p className={styles.caption}>{caption}</p> : null}
      </div>
    </div>
  );
}
